import Button from 'components/Button'
import copy from 'copy.json'
import { PencilIcon } from 'icons'
import type { ButtonHTMLAttributes } from 'react'

export default function RecalculateButton({
  children = copy.common.button.recalculate,
  ...props
}: ButtonHTMLAttributes<HTMLButtonElement>) {
  return (
    <Button small {...props}>
      <PencilIcon />
      {children}
    </Button>
  )
}
